export const GET_TAI_SAN_THEO_CHO_VAY = "GET_TAI_SAN_THEO_CHO_VAY";
export const GET_TAI_SAN_THEO_CHO_VAY_SUCCESS =
  "GET_TAI_SAN_THEO_CHO_VAY_SUCCESS";
export const GET_TAI_SAN_THEO_CHO_VAY_FAILURE =
  "GET_TAI_SAN_THEO_CHO_VAY_FAILURE";
export const GET_TAI_SAN = "GET_TAI_SAN";
export const GET_TAI_SAN_SUCCESS = "GET_TAI_SAN_SUCCESS";
export const GET_TAI_SAN_FAILURE = "GET_TAI_SAN_FAILURE";
export const GET_LICH_SU_TAI_SAN = "GET_LICH_SU_TAI_SAN";
export const GET_LICH_SU_TAI_SAN_SUCCESS = "GET_LICH_SU_TAI_SAN_SUCCESS";
export const GET_LICH_SU_TAI_SAN_FAILURE = "GET_LICH_SU_TAI_SAN_FAILURE";
